'use strict';

import angular from 'angular';
import ActivateRequestedController from './activate-requested.controller';

export default angular.module('conduuApp.activateRequested', [])
  .controller('ActivateRequestedController', ActivateRequestedController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/activate-requested/index.js